import React from "react";
import DocumentTypeBadge, { getDocumentTypeColor } from "./DocumentTypeBadge";

// Every supported file-type badge, built from the single DocumentTypeBadge
// component so all tables render an identical rounded-square badge.
const SUPPORTED_TYPES = [
  "png", "jpg", "jpeg", "gif", "webp", "tif", "tiff", "heic", "heif", "jfif", "ico",
  "pdf",
  "doc", "docx", "rtf", "pages",
  "xls", "xlsx", "csv",
  "ppt", "pptx",
  "txt", "bin",
  "zip", "rar",
  "mp3", "mp4", "mov", "wav", "m4a", "wma", "aac", "opus", "flac", "alac",
  "ogg", "midi", "aiff", "amr", "3gp", "mp1", "mp2", "mpa", "mpeg", "mpg", "wmv",
  "eml", "msg", "html", "htm", "mhtml", "url", "ics", "one", "vcf",
];

export const fileIcon = SUPPORTED_TYPES.reduce((acc, type) => {
  acc[type] = <DocumentTypeBadge type={type} />;
  return acc;
}, {});

// Folders aren't a file type, so they keep a distinct folder glyph rather
// than a text badge.
fileIcon.folder = (
  <svg
    style={{ width: "2em", height: "2em", verticalAlign: "middle", margin: "0 0.25em" }}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
  >
    <path fill="#FFA000" d="M40,12H22l-4-4H8c-2.2,0-4,1.8-4,4v8h40v-4C44,13.8,42.2,12,40,12z"></path>
    <path fill="#FFCA28" d="M40,12H8c-2.2,0-4,1.8-4,4v20c0,2.2,1.8,4,4,4h32c2.2,0,4-1.8,4-4V16C44,13.8,42.2,12,40,12z"></path>
  </svg>
);

export { getDocumentTypeColor };
export default fileIcon;
